export const MODULE_NAME = "home";
export const MODULE_UI_NAME = "Home";
export const ARTICLES_MODULE_NAME = "articles";
